//import sr from '@root/components/v2/ui-elements/CountryFlagIcons/sr.svg';
import React, { useState, useEffect } from 'react';

const country_flag_icons = {
  Andorra: 'ad',
  'United Arab Emirates': 'ae',
  Afghanistan: 'af',
  'Antigua and Barbuda': 'ag',
  Anguilla: 'ai',
  Albania: 'al',
  Armenia: 'am',
  Angola: 'ao',
  Antarctica: 'aq',
  Argentina: 'ar',
  'American Samoa': 'as',
  Austria: 'at',
  Australia: 'au',
  Aruba: 'aw',
  Azerbaijan: 'az',
  'Bosnia and Herzegovina': 'ba',
  Barbados: 'bb',
  Bangladesh: 'bd',
  Belgium: 'be',
  'Burkina Faso': 'bf',
  Bulgaria: 'bg',
  Bahrain: 'bh',
  Burundi: 'bi',
  Benin: 'bj',
  'Saint Barthélemy': 'bl',
  Bermuda: 'bm',
  Brunei: 'bn',
  Bolivia: 'bo',
  Brazil: 'br',
  Bahamas: 'bs',
  Bhutan: 'bt',
  'Bouvet Island': 'bv',
  Botswana: 'bw',
  Belarus: 'by',
  Belize: 'bz',
  Canada: 'ca',
  'Cocos (Keeling) Islands': 'cc',
  'DR Congo': 'cg',
  'Central African Republic': 'cf',
  'Congo Republic': 'cd',
  Switzerland: 'ch',
  'Ivory Coast': 'ch',
  'Cook Islands': 'ck',
  Chile: 'cl',
  Cameroon: 'cm',
  China: 'ch',
  Colombia: 'co',
  'Costa Rica': 'cr',
  Cuba: 'cu',
  'Cabo Verde': 'cv',
  Curaçao: 'cw',
  'Christmas Island': 'cx',
  Cyprus: 'cy',
  Czechia: 'cz',
  Germany: 'de',
  Djibouti: 'dj',
  Denmark: 'dk',
  Dominica: 'dm',
  'Dominican Republic': 'do',
  Algeria: 'dz',
  Ecuador: 'ec',
  Estonia: 'ee',
  Egypt: 'eg',
  'Western Sahara': 'eh',
  Eritrea: 'er',
  Spain: 'es',
  Ethiopia: 'et',
  Finland: 'fi',
  Fiji: 'fj',
  'Falkland Islands': 'fk',
  Micronesia: 'fm',
  'Faroe Islands': 'fo',
  France: 'fr',
  Gabon: 'ga',
  'United Kingdom': 'gb',
  Grenada: 'gd',
  Georgia: 'ge',
  'French Guiana': 'gf',
  Guernsey: 'gg',
  Ghana: 'gh',
  Gibraltar: 'gi',
  Greenland: 'gl',
  'The Gambia': 'gm',
  Guinea: 'gn',
  Guadeloupe: 'gp',
  'Equatorial Guinea': 'gq',
  Greece: 'gr',
  'South Georgia and South Sandwich Islands': 'gs',
  Guatemala: 'gt',
  Guam: 'gu',
  'Guinea-Bissau': 'gw',
  Guyana: 'gy',
  'Hong Kong': 'hk',
  'Honk Kong': 'hk',
  'Heard and McDonald Islands': 'hm',
  Honduras: 'hn',
  Croatia: 'hr',
  Haiti: 'ht',
  Hungary: 'hu',
  Indonesia: 'id',
  Ireland: 'ie',
  Israel: 'il',
  'Isle of Man': 'im',
  India: 'in',
  'British Indian Ocean Territory': 'io',
  Iraq: 'iq',
  Iran: 'ir',
  Iceland: 'is',
  Italy: 'it',
  Jersey: 'je',
  Jamaica: 'jm',
  Jordan: 'jo',
  Japan: 'jp',
  Kenya: 'ke',
  Kyrgyzstan: 'kg',
  Cambodia: 'kh',
  Kiribati: 'ki',
  Comoros: 'km',
  'St Kitts and Nevis': 'kn',
  'North Korea': 'kp',
  'South Korea': 'kr',
  Kuwait: 'kw',
  'Cayman Islands': 'ky',
  Kazakhstan: 'kz',
  Laos: 'la',
  Lebanon: 'lb',
  'Saint Lucia': 'lc',
  Liechtenstein: 'li',
  'Sri Lanka': 'lk',
  Liberia: 'lr',
  Lesotho: 'ls',
  Lithuania: 'lt',
  Luxembourg: 'lu',
  Latvia: 'lv',
  Libya: 'ly',
  Morocco: 'ma',
  Monaco: 'mc',
  Moldova: 'md',
  Montenegro: 'me',
  'Saint Martin': 'mf',
  Madagascar: 'mg',
  'Marshall Islands': 'mh',
  'North Macedonia': 'mk',
  Mali: 'ml',
  Myanmar: 'mm',
  Mongolia: 'mn',
  Macao: 'mo',
  'Northern Mariana Islands': 'mp',
  Martinique: 'mq',
  Mauritania: 'mr',
  Montserrat: 'ms',
  Malta: 'mt',
  Mauritius: 'mu',
  Maldives: 'mv',
  Malawi: 'mw',
  Mexico: 'mx',
  Malaysia: 'my',
  Mozambique: 'mz',
  Namibia: 'na',
  'New Caledonia': 'nc',
  Niger: 'ne',
  'Norfolk Island': 'nf',
  Nigeria: 'ng',
  Nicaragua: 'ni',
  'The Netherlands': 'nl',
  Netherlands: 'nl',
  Norway: 'no',
  Nepal: 'np',
  Nauru: 'nr',
  Niue: 'nu',
  'New Zealand': 'nz',
  Oman: 'om',
  Panama: 'pa',
  Peru: 'pe',
  'French Polynesia': 'pf',
  'Papua New Guinea': 'pg',
  Philippines: 'ph',
  Pakistan: 'pk',
  Poland: 'pl',
  'Saint Pierre and Miquelon': 'pm',
  'Pitcairn Islands': 'pn',
  'Puerto Rico': 'pr',
  Palestine: 'ps',
  Portugal: 'pt',
  Palau: 'pw',
  Paraguay: 'py',
  Qatar: 'qa',
  Réunion: 're',
  Romania: 'ro',
  Serbia: 'rs',
  Russia: 'ru',
  Rwanda: 'rw',
  'Saudi Arabia': 'sa',
  'Solomon Islands': 'sb',
  Seychelles: 'sc',
  Sudan: 'sd',
  Sweden: 'se',
  Singapore: 'sg',
  'Saint Helena': 'sh',
  Slovenia: 'si',
  'Svalbard and Jan Mayen': 'sj',
  Slovakia: 'sk',
  'Sierra Leone': 'sl',
  'San Marino': 'sm',
  Senegal: 'sn',
  Somalia: 'so',
  Suriname: 'sr',
  'South Sudan': 'ss',
  'São Tomé and Príncipe': 'st',
  'El Salvador': 'sv',
  'Sint Maarten': 'sx',
  Syria: 'sy',
  Eswatini: 'sz',
  'Turks and Caicos Islands': 'tc',
  Chad: 'cd',
  'French Southern Territories': 'tf',
  Togo: 'tg',
  Thailand: 'th',
  Tajikistan: 'tj',
  Tokelau: 'tk',
  'Timor-Leste': 'tl',
  Turkmenistan: 'tm',
  Tunisia: 'tn',
  Tonga: 'to',
  Türkiye: 'tr',
  'Trinidad and Tobago': 'tt',
  Tuvalu: 'tv',
  Taiwan: 'tw',
  Tanzania: 'tz',
  Ukraine: 'ua',
  Uganda: 'ug',
  'United States': 'us',
  Uruguay: 'uy',
  Uzbekistan: 'uz',
  'Vatican City': 'uz',
  'St Vincent and Grenadines': 'vc',
  Venezuela: 've',
  'British Virgin Islands': 'vg',
  'U.S. Virgin Islands': 'vi',
  Vietnam: 'vn',
  Vanuatu: 'vu',
  'Wallis and Futuna': 'wf',
  Samoa: 'ws',
  Kosovo: 'ws',
  Yemen: 'ye',
  Mayotte: 'yt',
  'South Africa': 'za',
  Zambia: 'zm',
  Zimbabwe: 'zw',
  global: 'global',
  Global: 'global',
};

// Every code that has a flag file, so an ISO code can pick the flag without matching a name.
const KNOWN_FLAG_CODES = new Set(Object.values(country_flag_icons));

// `code` (ISO 3166 alpha-2, any case) is optional and wins when it has a flag: display names vary
// by source ("Türkiye" vs "Turkey"), codes do not. Without it, the flag is looked up by `name`.
const CountryFlagIcons = ({ height = '20px', width = '20px', name, code, isRounded }) => {
  const [icon, setIcon] = useState('');
  const codeKey = String(code ?? '').toLowerCase();
  const flagKey = KNOWN_FLAG_CODES.has(codeKey) ? codeKey : country_flag_icons[name];
  // console.log(name, country_flag_icons[name], 'namekkk');
  useEffect(() => {
    if (!flagKey) return;
    async function fetchData() {
      const importedIcon = await import(`./CountryFlagIcons/${flagKey}.svg`);
      setIcon(importedIcon.default);
    }
    fetchData();
  }, [flagKey]);

  // Nothing until the flag has loaded: an <img> with no src renders its alt text, and alt used to be
  // the module path, so the panel showed ".../CountryFlagIcons/in.svg" as text.
  if (!flagKey || !icon) return null;

  return (
    <img
      alt={`${name || codeKey.toUpperCase()} flag`}
      src={icon}
      style={{
        width,
        height,
        ...(isRounded ? { borderRadius: '50%', objectFit: 'cover' } : {}),
      }}
    />
  );
};

export default CountryFlagIcons;
